export default __webpack_public_path__ + "static/assets/28c9baae5c79a44f877cca365a3e15f7.svg";